module.exports = __webpack_public_path__ + "static/media/image 17.f68022d8.png";